import { h, Fragment } from "preact";
import { useState, useRef, useContext } from "preact/hooks";
import ADControls from "./AudioDescription/components/ADControls";
import MediaPlayer from "./MediaPlayer/MediaPlayer";
import Transcript from "./transcript/components/Transcript";
import SearchProvider from "./features/utils/SearchProvider";
import { RootDataType } from "../types/rootDataTypes";

import SettingsContext from "./SettingsContext";
import { Footer } from "./shared/components";
import { seekVideo } from "./video-player-integration/video-player";

/**
 * Component for sharing state between features
 * Listens to onPlay and onPause
 * Shares state via playing prop on renderPlayer
 */

const RecordedContainer = ({
  available_audio_description_languages: adLangs,
  available_transcript_languages: tranLangs,
  name: mediaName,
}: RootDataType): h.JSX.Element => {
  const { settings } = useContext(SettingsContext);

  const [isAdEnabled, setIsAdEnabled] = useState<boolean>(false);
  const transcriptRef = useRef<HTMLDivElement>(null);

  const jumpToTranscript = () => {
    const firstFocusableElement = transcriptRef.current?.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    ) as HTMLElement | undefined;
    firstFocusableElement?.scrollIntoView();
    firstFocusableElement?.focus();
  };

  const renderAd = settings.showAd && Object.keys(adLangs).length > 0;
  const renderTranscript =
    settings.showTranscript && Object.keys(tranLangs).length > 0;

  return (
    <>
      <div>
        <div class="RecordedContainer-header">
          <h2
            class="RecordedContainer-title"
            data-hide-title={!!settings.hideTitle}
          >
            {mediaName}
          </h2>
          {(renderAd || renderTranscript) && (
            <div class="RecordedContainer-controls posRelative noOverflow">
              {renderAd && (
                <ADControls toggled={isAdEnabled} onToggle={setIsAdEnabled} />
              )}
              {renderTranscript && (
                <button
                  data-testid="skiplink"
                  class="skipLink"
                  onClick={() => jumpToTranscript()}
                >
                  Skip to Transcript
                </button>
              )}
            </div>
          )}
        </div>
        <MediaPlayer
          hasAD={renderAd}
          isAdEnabled={isAdEnabled}
          controls
          width="100%"
          extended={adLangs["en"]?.extended}
        />
      </div>

      {renderTranscript ? (
        <SearchProvider>
          <Transcript
            tranLangs={tranLangs}
            onWordClick={(val) => {
              seekVideo.value(val);
            }}
            ref={transcriptRef}
          />
        </SearchProvider>
      ) : (
        <Footer />
      )}
    </>
  );
};

export default RecordedContainer;
